<template>
  <div class="label__link w-inline-block">
    <LKIconCount
      v-if="count"
      :count="count"
      class="LKIconHistory__count"
    />

    <v-icon class="LKIconHistory__icon">
      mdi-history
    </v-icon>
  </div>
</template>

<script>
import LKIconCount from './LKIconCount.vue'


export default {
  name: 'LKIconHistory',
  components: {
    LKIconCount,
  },
  props: {
    count: [Number, String],
  },
}
</script>

<style lang="scss">
.LKIconHistory {
  &__count {
    position: absolute;
    right: -10px;
    bottom: auto;
    left: auto;
  }

  &__icon {
    color: $color-black !important;
  }
}
</style>
